import jsCookie from 'js-cookie';

import MAEvent from './ma-event';

const REALYTICS_ID = 'ry-m31lle2';

const tags = {
    DDE: 'demande_evaluation_direct',
    DDEI: 'demande_evaluation_indirect',
};

let isInitialized = false;

/**
 * Initialize Realytics tracking by injecting script in the DOM
 */
function initialize() {
    /* eslint-disable */
    window.RY = (function(e) {
        let t = [
            'identify',
            'track',
            'trackLink',
            'trackForm',
            'transaction',
            'page',
            'profile',
            'sync',
        ];
        let n = 'realytics';
        let r = function(e) {
            return !!(e && (typeof e == 'function' || typeof e == 'object'));
        };
        let i = function(e, t) {
            return function() {
                let n = Array.prototype.slice.call(arguments);
                if (!e[t]) e[t] = [];
                e[t].push(n ? n : []);
                if (!e['_q']) e['_q'] = [];
                e['_q'].push(t);
            };
        };
        let s = function(r) {
            for (let s = 0; s < t.length; s++) {
                let o = t[s];
                if (r) e[r][o] = i(e._q[r], o);
                else e[o] = e[n][o] = i(e._q[n], o);
            }
        };
        let o = function(t, r, i) {
            let o = t ? t : n;
            if (!e[o]) e[o] = {};
            if (!e._q[o]) e._q[o] = {};
            if (r) e._q[o]['init'] = [[r, i ? i : null]];
            s(t);
        };
        if (!e._v) {
            if (!e._q) {
                e._q = {};
                o(null, null, null);
            }
            e.init = function(e, n) {
                let i = n ? (r(n) ? (n['name'] ? n['name'] : null) : n) : null;
                if (i && t) for (let s = 0; s < t.length; s++) if (i == t[s] || i == 'init') return;
                o(i, e, r(n) ? n : null);
                let u = function(e) {
                    let t = document.createElement('script');
                    t.type = 'text/javascript';
                    t.async = true;
                    t.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + e;
                    let n = document.getElementsByTagName('script')[0];
                    n.parentNode.insertBefore(t, n);
                };
                u('i.realytics.io/tc.js?cb=' + new Date().getTime());
                u('cdn-eu.realytics.net/realytics-1.2.min.js');
            };
        }
        return e;
    })(window.RY || {});
    /* eslint-enable */

    window.RY.init(REALYTICS_ID);
    window.RY.page();
    isInitialized = true;
}

/**
 * Remove cookies used by Realytics to identify user
 */
function removeCookies() {
    const cookieOptions = { domain: MA.Config.SESSION_COOKIE_DOMAIN };
    jsCookie.remove(`ry_${REALYTICS_ID}_realytics`, cookieOptions);
    jsCookie.remove(`ry_${REALYTICS_ID}_so_realytics`, cookieOptions);
}

/**
 * Emit a tag to Realytics API
 *
 * @param {String} tag
 */
function track(tag) {
    if (isInitialized) {
        window.RY.track(tag);
    }
}

/**
 * Track DDE form submission
 */
function trackDDE() {
    track(tags.DDE);
}

/**
 * Track DDEi form submission
 */
function trackDDEi() {
    track(tags.DDEI);
}

/**
 * Bind a form with realytics tracking
 *
 * @param {jQuery} $form jQuery form element to bind
 * @param {Function} trackFunction track function to execute after a form event
 * @param {Event} [formEvent] event
 */
function bindForm($form, trackFunction, formEvent = MAEvent.formSubmitSuccess) {
    $form.one(formEvent, trackFunction);
}

export default { initialize, removeCookies, trackDDE, trackDDEi, bindForm };
